import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import ClockIcon from '../icons/ClockIcon';
import PhoneIcon from '../icons/PhoneIcon';
import LocationIcon from '../icons/LocationIcon';
import FacebookIcon from '../icons/FacebookIcon';
import TwitterIcon from '../icons/TwitterIcon';
import InstagramIcon from '../icons/InstagramIcon';
import LinkedInIcon from '../icons/LinkedInIcon';

const TopBarContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff',
  padding: '21px 315px',
  borderBottom: '1px solid #f0f0f0',
  [theme.breakpoints.down('lg')]: {
    padding: '16px 80px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '12px 16px'
  }
}));

const TopBarContent = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

const ContactInfo = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '40px',
  flexWrap: 'wrap'
}));

const ContactItem = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '9px'
}));

const ContactText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Nunito, sans-serif',
  fontSize: '13px',
  fontWeight: 400,
  letterSpacing: '0.10px',
  color: '#797c7f'
}));

const SocialIcons = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px'
}));

const TopContactBar = ({ topContactInfo }) => {
  const phone = topContactInfo?.phone || '1-800-458-56987';
  const address = topContactInfo?.address || '47 Bakery Street, London, UK';
  const mapsHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  const socials = topContactInfo?.socialMedia || {};

  return (
    <TopBarContainer>
      <TopBarContent>
        <ContactInfo>
          <ContactItem>
            <ClockIcon width={16} height={16} color="#797c7f" />
            <ContactText>
              {topContactInfo?.hours || 'Mon - Fri 8:00 - 18:00 / Sunday 8:00 - 14:00'}
            </ContactText>
          </ContactItem>
          
          <ContactItem>
            <PhoneIcon width={16} height={16} color="#797c7f" />
            <ContactText component="a" href={`tel:${phone.replace(/\s+/g, '')}`} sx={{ textDecoration: 'none' }}>
              {phone}
            </ContactText>
          </ContactItem>
          
          <ContactItem>
            <LocationIcon width={14} height={16} color="#797c7f" />
            <ContactText component="a" href={mapsHref} target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'none' }}>
              {address}
            </ContactText>
          </ContactItem>
        </ContactInfo>
        
        <SocialIcons>
          <a href={socials.facebook || '#'} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FacebookIcon width={8} height={15} color="#0d2b23" />
          </a>
          <a href={socials.twitter || '#'} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <TwitterIcon width={19} height={13} color="#0d2b23" />
          </a>
          <a href={socials.instagram || '#'} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <InstagramIcon width={15} height={15} color="#0d2b23" />
          </a>
          <a href={socials.linkedin || '#'} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <LinkedInIcon width={15} height={15} color="#0d2b23" />
          </a>
        </SocialIcons>
      </TopBarContent>
    </TopBarContainer>
  );
};

export default TopContactBar;